import Loadable from 'components/Loadable';

const isoSurvey = {
  exact: true,
  path: '/iso-survey',
  component: Loadable({
    loader: () => import('../views/iso-survey'),
  }),
};

export default isoSurvey;
